import React, { useState, useEffect } from 'react';
import { fetchEcrituresComptables } from '../../api/ecrituresComptablesApi';

const EcrituresComptables = () => {
  const [ecritures, setEcritures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEcritures = async () => {
      try {
        const data = await fetchEcrituresComptables(); // Utilise la fonction importée
        setEcritures(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadEcritures();
  }, []);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Erreur : {error}</div>;

  return (
    <div className="ecritures-comptables">
      <h2>Liste des écritures comptables</h2>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Libellé</th>
            <th>Compte</th>
            <th>Débit</th>
            <th>Crédit</th>
          </tr>
        </thead>
        <tbody>
          {ecritures.map((ecriture) => (
            <tr key={ecriture.id}>
              <td>{new Date(ecriture.date).toLocaleDateString()}</td>
              <td>{ecriture.libelle}</td>
              <td>{ecriture.compte}</td>
              <td>{ecriture.debit}</td>
              <td>{ecriture.credit}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EcrituresComptables;